import { AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import {
    getDefaultHeaders,
    instance as axiosInstance,
    useAlert,
    withHeaders,
} from '../core';
import { commonShowAlert } from '../lib';
import { FILE_UPLOAD_SUCCESS_MSG } from '../pages/job-manager/job-manager-helper';

interface SaveDictionaryJobProps {
    token: string;
    job: any;
}

const saveDictionary = (props: SaveDictionaryJobProps): any => {
    const { token, job } = props;
    const headers = getDefaultHeaders(token);

    const saveDictionaryJobUrl = `/jobs/dictionary`;
    return axiosInstance().post(
        saveDictionaryJobUrl,
        job,
        withHeaders(headers)
    );
};

/**
 * NOTE: add/edit dictionary job have the same URL so we are combining both functionalities into
 * a shared save function rather than separating them into add and update like in the other mutation hooks.
 * @param props - The required SaveDictionaryJobProps
 */
export const useSaveDictionaryJob = (props: {
    isEdit: boolean;
}): UseMutationResult<AxiosResponse<any>, unknown, SaveDictionaryJobProps> => {
    const queryClient = useQueryClient();
    const { showAlert, hideAlert, showErrorDetails } = useAlert();
    const { isEdit } = props;

    return useMutation(saveDictionary, {
        onSuccess: () => {
            queryClient.invalidateQueries('jobs');
            commonShowAlert(
                showAlert,
                hideAlert,
                'success',
                FILE_UPLOAD_SUCCESS_MSG
            );
        },
        onError: (error: any) => {
            const errMessage = isEdit
                ? 'Unable to update dictionary'
                : 'Unable to create dictionary';
            const errorMessage: string = error?.data?.message ?? errMessage;
            commonShowAlert(
                showAlert,
                hideAlert,
                'error',
                errorMessage,
                JSON.stringify(error?.data ?? ''),
                showErrorDetails
            );
        },
    });
};
